import React, { createContext, useContext, useMemo, useReducer } from 'react';

const emptyBookingEventContextValue = {
    prop1: null,
    action1: () => {},
};

export const BookingEventContext = createContext(emptyBookingEventContextValue);
const BookingEventDispatchContext = createContext(null);

export const BookingEventContextProvider = ({ isMobile, breakpoint: breakpoint, children }) => {
    const BookingEventContextValue = useMemo(
        () => ({
            isMobile: isMobile,
            breakpoint: breakpoint,
        }),
        [isMobile]
    );

    const [data, dispatch] = useReducer(BookingEventReducer, BookingEventContextValue);

    return (
        <BookingEventContext.Provider value={data}>
            <BookingEventDispatchContext.Provider value={dispatch}>{children}</BookingEventDispatchContext.Provider>
        </BookingEventContext.Provider>
    );
};

export function useBookingEvent() {
    return useContext(BookingEventContext);
}

export function useBookingEventDispatch() {
    return useContext(BookingEventDispatchContext);
}

const BookingEventReducer = (state, action) => {
    switch (action.type) {
        case 'TestAction':
            return {
                ...state,
            };
        default:
            return state;
    }
};
